import {
  ELSCommonConfig,
  ELSCommonUIConstants,
} from '@els/els-ui-common-react';
import { ELSFormFieldConfig } from '@els/els-component-form-field-react';
import { ServicePath } from './app.constants';
import { ServerConstants } from './server.constants';
import { DATE_FORMAT } from '../../constants/date.constants';

// Runs at module scope during bootstrap, before any ErrorBoundary exists. A sandboxed iframe
// without allow-same-origin can throw a SecurityError on window.top, so fall back to the
// standalone copy rather than taking the whole app down.
export const isEmbeddedInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return false;
  }
};

export const setDefaultAppConfig = (): void => {

  ELSCommonConfig.setBuildUrl(ServerConstants[ServerConstants.DataSource].gatewayBaseURL);
  ELSCommonConfig.setLoginPath(ServicePath.loginPath);
  ELSCommonConfig.setUserServicePath(ServicePath.userServicePath);
  ELSCommonConfig.setTokenServicePath(ServicePath.tokenServicePath);
  ELSCommonConfig.setStorageDriver(ELSCommonUIConstants.security.Locker.SecondaryDriver);
  ELSCommonConfig.setAppId('NHE_AI');
  ELSCommonConfig.addTestUserEmailDomains('osmosis.org');
  ELSCommonConfig.setUseAppParams(true);
  ELSCommonConfig.setI18Messages({
    timeoutHeading: 'Your session disconnected due to inactivity. To reconnect, please sign back in.',
    timeoutResolution: isEmbeddedInIframe()
      ? 'Please refresh the page to reconnect.'
      : 'Please return to your learning management system and log in to access this content.',
    warningHeading: '',
    warningMessage: 'Due to inactivity, you will be logged out soon. Would you like to stay logged in?'
  });
  ELSFormFieldConfig.setI18nConfig({
    dateFormat: {
      primary: DATE_FORMAT
    }
  });
};
